import { configure } from '@mobi/ds'
import { ENV } from 'gatsby-env-variables'
import Root from './src/Root'
import analytics from '@mobi/libraries/analytics'
import makeTrackings from './src/utils/make'
import { isSourceOrigin } from 'utils/isSourceOrigin'
import { make } from '@mobi/libraries/analytics'
import ROUTES from './src/Routes'
import { addNRPagePerformance } from './src/utils/newRelicEvents'
import { SEGMENT_ID } from 'gatsby-env-variables'

configure({
  originFonts: 'extern',
  fonts: {
    ItauDisplay: [900],
    ItauText: [400, 700],
  },
  setStyleVariablesInHTML: false,
})

const stagingMake = {
  writeKey: 'wk_2EP5qJVmuft6CwtbRZDbicz1Alq',
  sourceKey: 'src_2EP5qEV0lil4v0Id6TsRQtUzn4Q',
}

const productionMake = {
  writeKey: 'wk_2EP5iKLBYABf6caUx5sqSRhrQuC',
  sourceKey: 'src_2EP5iNhah7PotvGssqbAAaK5GMT',
}

const makeTagular = ENV === 'prod' ? productionMake : stagingMake

if (!isSourceOrigin('pivo')) {
  analytics.setup({
    segmentId: SEGMENT_ID,
    makeTagular,
    trackings: makeTrackings,
  })
}

const getRouteByPathname = (pathname) => {
  const home = {
    path: '/',
    pageName: 'home',
  }

  const route = Object.values(ROUTES).find((route) => route.path === pathname)

  const isHome = pathname === home.path

  return isHome ? { pageName: home.pageName } : route || { pageName: '' }
}

export const onRouteUpdate = async ({ location, prevLocation }) => {
  const route = getRouteByPathname(location.pathname)

  addNRPagePerformance(route.pageName)

  const hasCohesionPageViewed = async () => {
    const hasCohesion = window?._Cohesion
    const hasCohesionPage = window?._Cohesion?.webContext?.page

    if (hasCohesion && hasCohesionPage) {
      clearInterval(pageViewedInterval)

      make.track('redventures.usertracking.v2.PageViewed', {
        pageName: `viewed_${route.pageName}`,
        webContext: {
          ...window._Cohesion.webContext,
          fromManual: true,
          page: {
            ...window._Cohesion.webContext.page,
            referrer: prevLocation?.href || '',
            title: document.title,
            url: location.href,
          },
        },
      })
    }
  }
  const pageViewedInterval = setInterval(hasCohesionPageViewed, 350)
}

export const wrapRootElement = Root
